import { NavLink, Outlet, useLocation, Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/lib/auth";
import {
  LayoutDashboard, Users, Building2, FileSignature, Dumbbell, Calendar, MapPin, Footprints, FileText,
  Radio, MessageSquare, ClipboardList, CheckSquare, Receipt, Bell, Settings, LogOut, Inbox, Home,
} from "lucide-react";

const ITEMS = [
  { to: "/admin", icon: LayoutDashboard, label: "Dashboard", end: true },
  { to: "/admin/guards", icon: Users, label: "Guards" },
  { to: "/admin/clients", icon: Building2, label: "Clients" },
  { to: "/admin/contracts", icon: FileSignature, label: "Contracts" },
  { to: "/admin/trainings", icon: Dumbbell, label: "Training" },
  { to: "/admin/shifts", icon: Calendar, label: "Shifts" },
  { to: "/admin/tracking", icon: MapPin, label: "Live tracking" },
  { to: "/admin/tours", icon: Footprints, label: "Site tours" },
  { to: "/admin/reports", icon: FileText, label: "Reports" },
  { to: "/admin/dispatch", icon: Radio, label: "Dispatch" },
  { to: "/admin/messenger", icon: MessageSquare, label: "Messenger" },
  { to: "/admin/post-orders", icon: ClipboardList, label: "Post orders" },
  { to: "/admin/tasks", icon: CheckSquare, label: "Tasks" },
  { to: "/admin/invoices", icon: Receipt, label: "Invoices" },
  { to: "/admin/inbox", icon: Inbox, label: "Inbox" },
  { to: "/admin/notifications", icon: Bell, label: "Notifications" },
  { to: "/admin/settings", icon: Settings, label: "Settings" },
];

export const AdminLayout = () => {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const current = ITEMS.find(i => i.end ? loc.pathname === i.to : loc.pathname.startsWith(i.to + "")) || ITEMS[0];

  return (
    <div className="min-h-screen bg-navy" style={{ display: "grid", gridTemplateColumns: "240px 1fr" }}>
      <aside style={{ borderRight: "1px solid var(--border-dark)", background: "var(--shield-navy)" }}>
        <div className="px-5 py-5" style={{ borderBottom: "1px solid var(--border-dark)" }}>
          <Logo size={48} compact />
        </div>
        <nav className="py-3">
          {ITEMS.map(i => (
            <NavLink key={i.to} to={i.to} end={i.end}
                     className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
                     data-testid={`nav-${i.label}`}>
              <i.icon size={16} />
              <span>{i.label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>

      <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        <header style={{ background: "var(--shield-navy)", borderBottom: "1px solid var(--border-dark)" }}>
          <div className="px-8 py-4 flex items-center justify-between">
            <div>
              <div className="text-muted" style={{ fontSize: 12 }}>Admin Console</div>
              <div className="h-page mt-0.5">{current?.label || "Dashboard"}</div>
            </div>
            <div className="flex items-center gap-4">
              <Link to="/" className="text-muted hover:text-white inline-flex items-center gap-1.5" style={{ fontSize: 13 }} data-testid="back-to-site-admin">
                <Home size={14} /> Back to site
              </Link>
              <div className="text-right">
                <div style={{ fontSize: 13 }}>{user?.name}</div>
                <div className="text-muted" style={{ fontSize: 11 }}>{user?.role?.replace("_"," ")}</div>
              </div>
              <button onClick={logout} className="btn-outline flex items-center gap-2" data-testid="logout-btn">
                <LogOut size={14} /> Sign out
              </button>
            </div>
          </div>
        </header>
        <main className="p-8" style={{ flex: 1 }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};
